/**
 * EN-4111: a channel the orders pages name themselves. A manual order (made on
 * the create order page) has the channel `manual`: no marketplace logo, so a
 * neutral icon and the word "Manual". Any other channel keeps its own name.
 */
export const MANUAL_CHANNEL = 'manual';

export const isManualChannel = (type: string | null | undefined) =>
  type?.trim().toLowerCase() === MANUAL_CHANNEL;

export const channelLabel = (type: string | null | undefined) =>
  isManualChannel(type) ? 'Manual' : (type ?? '');
